import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { createProductMultipart } from "../api/products";

function AddProductPage() {
    var navigate = useNavigate();

    var [form, setForm] = useState({
        name: "",
        price: "",
        description: "",
        category: "",
        quantity: "",
        size: "",
        wood: "",
        subcategory: "",
        imageFile: null
    });

    var [preview, setPreview] = useState(null);
    var [saving, setSaving] = useState(false);
    var [error, setError] = useState(null);

    var MAX_MB = 10; // drž sa limitu BE (nastavili sme 20MB)

    function handleChange(e) {
        var name = e.target.name;
        var value = e.target.value;
        var copy = Object.assign({}, form);
        copy[name] = value;
        setForm(copy);
    }

    function handleFileChange(e) {
        var file = e.target.files && e.target.files[0] ? e.target.files[0] : null;

        if (file && file.size > MAX_MB * 1024 * 1024) {
            setError("Súbor je príliš veľký (max " + MAX_MB + " MB).");
            e.target.value = "";
            return;
        }

        var copy = Object.assign({}, form);
        copy.imageFile = file;
        setForm(copy);

        if (file) {
            var r = new FileReader();
            r.onloadend = function () { setPreview(r.result); };
            r.readAsDataURL(file);
        } else {
            setPreview(null);
        }
    }

    function toNumberOrZero(value) {
        var n = parseFloat(value);
        if (isNaN(n)) { return 0; }
        return n;
    }

    function toIntOrZero(value) {
        var n = parseInt(value, 10);
        if (isNaN(n)) { return 0; }
        if (n < 0) { return 0; }
        return n;
    }

    function handleSubmit(e) {
        e.preventDefault();

        if (!form.name || !form.price) {
            setError("Názov a cena sú povinné.");
            return;
        }

        setError(null);
        setSaving(true);

        var payload = {
            name: form.name,
            price: toNumberOrZero(form.price),
            description: form.description,
            category: form.category && form.category.trim().length > 0 ? form.category.trim() : "General",
            quantity: toIntOrZero(form.quantity),
            size: form.size,
            wood: form.wood,
            subcategory: form.subcategory,
            imageFile: form.imageFile // backend spraví slug, upload do R2, uloží imageUrl
        };

        createProductMultipart(payload)
            .then(function (created) {
                // očakávame 201 + JSON Product { id, slug, ... }
                if (!created || !created.slug) {
                    throw new Error("Produkt vytvorený, ale chýba slug.");
                }
                navigate("/produkt/" + created.slug);
            })
            .catch(function (err) {
                setError(err && err.message ? err.message : "Chyba pri uložení produktu.");
            })
            .finally(function () {
                setSaving(false);
            });
    }

    return (
        <div className="container py-4">
            <h1 className="h4 mb-3">Pridať produkt</h1>
            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleSubmit} className="row g-3">
                <div className="col-md-6">
                    <label className="form-label">Názov *</label>
                    <input
                        name="name"
                        className="form-control"
                        value={form.name}
                        onChange={handleChange}
                        required
                    />
                    {/*<div className="form-text">Podľa názvu backend vygeneruje slug aj názov súboru v R2.</div>*/}
                </div>

                <div className="col-md-3">
                    <label className="form-label">Cena (€) *</label>
                    <input
                        name="price"
                        type="number"
                        step="0.01"
                        min="0"
                        className="form-control"
                        value={form.price}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-3">
                    <label className="form-label">Sklad (ks)</label>
                    <input
                        name="quantity"
                        type="number"
                        min="0"
                        step="1"
                        className="form-control"
                        value={form.quantity}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-3">
                    <label className="form-label">Kategória</label>
                    <input
                        name="category"
                        className="form-control"
                        value={form.category}
                        onChange={handleChange}
                        placeholder="napr. Hodiny"
                    />
                </div>

                <div className="col-md-3">
                    <label className="form-label">Podkategória</label>
                    <input
                        name="subcategory"
                        className="form-control"
                        value={form.subcategory}
                        onChange={handleChange}
                        placeholder="napr. Lesícke"
                    />
                </div>

                <div className="col-md-3">
                    <label className="form-label">Veľkosť</label>
                    <input
                        name="size"
                        className="form-control"
                        value={form.size}
                        onChange={handleChange}
                        placeholder="napr. 30 cm"
                    />
                </div>

                <div className="col-md-3">
                    <label className="form-label">Drevo</label>
                    <input
                        name="wood"
                        className="form-control"
                        value={form.wood}
                        onChange={handleChange}
                        placeholder="napr. Jaseň"
                    />
                </div>

                <div className="col-12">
                    <label className="form-label">Popis</label>
                    <textarea
                        name="description"
                        className="form-control"
                        rows="3"
                        value={form.description}
                        onChange={handleChange}
                    ></textarea>
                </div>

                <div className="col-md-6">
                    <label className="form-label">Obrázok produktu</label>
                    <input
                        type="file"
                        accept="image/*"
                        className="form-control"
                        onChange={handleFileChange}
                    />
                    {preview && (
                        <img
                            src={preview}
                            alt="Náhľad"
                            className="img-thumbnail mt-2"
                            style={{ maxWidth: "220px" }}
                        />
                    )}
                    <div className="form-text">Max {MAX_MB} MB.</div>
                </div>

                <div className="col-12 d-flex gap-2">
                    <button type="submit" className="btn btn-brown rounded-pill px-4" disabled={saving}>
                        {saving ? "Ukladám…" : "Uložiť"}
                    </button>
                    <Link to="/ponuka" className="btn btn-outline-secondary rounded-pill">Zrušiť</Link>
                </div>
            </form>
        </div>
    );
}

export default AddProductPage;
